/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListUnhandledMatchesMatchDtoFromJSON, ListUnhandledMatchesMatchDtoToJSON, } from './ListUnhandledMatchesMatchDto.js';
/**
 * Check if a given object implements the ListUnhandledMatchesResult interface.
 */
export function instanceOfListUnhandledMatchesResult(value) {
    if (!('matches' in value) || value['matches'] === undefined)
        return false;
    return true;
}
export function ListUnhandledMatchesResultFromJSON(json) {
    return ListUnhandledMatchesResultFromJSONTyped(json, false);
}
export function ListUnhandledMatchesResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matches': (json['matches'].map(ListUnhandledMatchesMatchDtoFromJSON)),
    };
}
export function ListUnhandledMatchesResultToJSON(json) {
    return ListUnhandledMatchesResultToJSONTyped(json, false);
}
export function ListUnhandledMatchesResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matches': (value['matches'].map(ListUnhandledMatchesMatchDtoToJSON)),
    };
}
